import { TextSmall } from 'components/chroma/extended';
import React, { FunctionComponent } from 'react';

const Disclaimer: FunctionComponent<{
  symbol: string;
  content: JSX.Element;
}> = ({ symbol, content }) => (
  <TextSmall>
    <sup>&nbsp;{symbol}</sup>&nbsp;
    {content}
  </TextSmall>
);

export { Disclaimer };
